import { render, staticRenderFns } from "./ButtonChat.vue?vue&type=template&id=533f3308&scoped=true&lang=pug"
import script from "./ButtonChat.vue?vue&type=script&lang=js"
export * from "./ButtonChat.vue?vue&type=script&lang=js"
import style0 from "./ButtonChat.vue?vue&type=style&index=0&id=533f3308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f3308",
  null
  
)

export default component.exports